export const LANGUAGES: Array<string> = [
  'en',
  'de',
  'bg'
];
